import React from 'react';
import { Link } from 'react-router-dom';
import Commonbg from '../assets/images/page-bg1.jpg';
//import Bgoverlay from '../assets/images/overlay-bg.png';

const BannerInner = (props) => {    

    return (
        <div className="w-full h-auto pt-16 sm:pt-24 md:pt-32 pb-6 flex relative">
            <div className='w-full h-full flex absolute top-0 left-0 bg-opacity-100 bg-no-repeat bg-cover bg-center bg-fixed z-[1]' style={{backgroundImage:`url(${Commonbg})`}}></div>
            {/* <div className='absolute w-full h-full bg-repeat bg-center bg-opacity-10 z-[2] left-0 top-0' style={{backgroundImage:`url(${Bgoverlay})`}}></div> */}
            <div className='absolute w-full h-full bg-gradient-to-r from-slate-950 to-transparent bg-opacity-60 z-[2] left-0 top-0'></div>
            <div className="container mx-auto z-10">
                <div className="flex flex-col">
                    <h2 className='text-3xl font-semibold text-orange-300 uppercase my-2'>{props.title}</h2>
                    <ul className="flex items-center whitespace-nowrap font-light text-gray-100" aria-label="Breadcrumb">
                        <li className="inline-flex items-center">
                            <Link className="flex items-center text-sm  hover:text-orange-500 focus:outline-none focus:text-orange-500" to={'/'}>
                                <svg className="flex-shrink-0 me-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                                Home
                            </Link>
                            <svg className="flex-shrink-0 mx-1 overflow-visible h-4 w-4 " xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                        </li>
                        <li className="inline-flex items-center text-sm  truncate" aria-current="page">
                            {props.title}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default BannerInner;